import React, { useEffect } from "react";
import K2Api from "lib/ajax/K2Api";

function Logout() {

  useEffect(() => {
    const k2Api = new K2Api();
    async function APILogOut() {
      try {
        await k2Api.delete(`/session`);
        localStorage.removeItem('session');
      } catch (err) {
        console.error(err.response, window.location);
      }
    }
    APILogOut();
  }, []);

  return <>
    <div className="text-center">
      <h1 className="display-1 font-weight-bold">Logged Out</h1>
      <p className="h1">Disconnected</p>
      <p className="h2 font-weight-normal mt-3 mb-4">
        Logged Out correctly! See you soon.
      </p>
    </div>
  </>;
}

export default Logout;
